import setAuthAction from '@glass/shared/modules/auth/setAuthAction';

const signInAuthAction =
  (auth, props) =>
  (dispatch, getState, { tracking }) => {
    const result = dispatch(setAuthAction(auth));
    tracking.login(auth.user, props);
    return result;
  };

export default signInAuthAction;
